import { useEffect, useState } from 'react';

const useService = () => {
  const [services, setServices] = useState([]);

  //   useEffect(() => {
  //     fetch('/fakeService.JSON')
  //       .then((res) => res.json())
  //       .then((data) => setServices(data));
  //   }, []);

  useEffect(() => {
    setServices(ServicesData);
  }, []);

  return [services];
};

export default useService;

const ServicesData = [
  {
    id: '07',
    title: 'Scars Treatment',
    description:
      'Scars are a common skin concern that can be caused by a variety of factors, including acne, surgery, injuries, and burns. At our clinic, we offer a range of...',
    image: 'https://cdn-icons-png.flaticon.com/512/4614/4614159.png',
    detailDesc:
      'Scars are a common skin concern that can be caused by a variety of factors, including acne, surgery, injuries, and burns. At our clinic, we offer a range of treatments to help reduce the appearance of scars and improve skin texture and tone.',
  },
  {
    id: '06',
    title: 'Dark spots',
    description:
      'Dark spots, also known as hyperpigmentation, are a common skin concern for many people. They are caused by the overproduction of melanin, which gives color to our skin...',
    image: 'https://cdn-icons-png.flaticon.com/512/6187/6187103.png',
    detailDesc: `Dark spots, also known as hyperpigmentation, are a common skin concern for many people. They are caused by the overproduction of melanin, which gives color to our skin. Dark spots can be caused by sun damage, hormonal changes, aging, and acne.

      At our clinic, we offer a range of treatments to help reduce the appearance of dark spots and achieve clearer, more even-toned skin.`,
  },
  {
    id: '04',
    title: 'Fillers',
    description:
      'Dermal fillers are a popular cosmetic treatment used to restore volume and smooth out wrinkles and fine lines in the face. At our clinic, our experienced dermatologist doctor offers...',
    image: 'https://cdn-icons-png.flaticon.com/128/4178/4178168.png',
    detailDesc: `Dermal fillers are a popular cosmetic treatment used to restore volume and smooth out wrinkles and fine lines in the face. At our clinic, our experienced dermatologist doctor offers a variety of dermal fillers that are tailored to meet the unique needs and goals of each patient.

      Dermal fillers are made up of a gel-like substance that is injected into the skin to plump up and add volume to areas that have lost their fullness due to aging or other factors. Some of the common areas where dermal fillers are used in include the cheeks, lips, chin, and under-eye area.
      
      `,
  },
  {
    id: '05',
    title: 'Lips Augmentation',
    description:
      'Lip augmentation is a popular cosmetic treatment that can help enhance the volume, shape, and definition of the lips. At our clinic, our experienced dermatologist doctor offers...',
    image: 'https://cdn-icons-png.flaticon.com/512/2357/2357434.png',
    detailDesc: `Lip augmentation is a popular cosmetic treatment that can help enhance the volume, shape, and definition of the lips. At our clinic, our experienced dermatologist doctor offers a variety of lip augmentation treatments that are tailored to meet the unique needs and goals of each patient.

      Lip augmentation can be achieved through a variety of techniques, including dermal fillers, fat transfer, and lip implants. Each technique has its own unique advantages and considerations, and our dermatologist doctor will work with you to determine the best treatment option for your needs.`,
  },
  {
    id: '03',
    title: 'Facial',
    description:
      'Facial treatments are an essential part of maintaining healthy, radiant skin. At our clinic, our experienced dermatologist doctor offers a variety of facial...',
    image: 'https://cdn-icons-png.flaticon.com/512/2763/2763384.png',
    detailDesc: `Facial treatments are an essential part of maintaining healthy, radiant skin. At our clinic, our experienced dermatologist doctor offers a variety of facial treatments that are tailored to meet the unique needs of each patient.
      During a facial treatment, our dermatologist doctor will first assess your skin type and any specific concerns you may have, such as acne, wrinkles, or hyperpigmentation. Based on this assessment, our doctor will recommend a customized treatment plan that may include a variety of techniques and products to help improve the overall health and appearance of your skin.`,
  },
  {
    id: '02',
    title: 'Laser Hair Removal',
    description:
      'Laser hair removal is a popular cosmetic procedure that utilizes laser technology to safely and effectively remove unwanted hair from various areas of the body...',
    image: 'https://cdn-icons-png.flaticon.com/512/1005/1005676.png',
    detailDesc: `Laser hair removal is a popular cosmetic procedure that utilizes laser technology to safely and effectively remove unwanted hair from various areas of the body. At our clinic, we offer state-of-the-art laser hair removal treatments that are performed by our experienced and highly trained dermatologist doctor.
      During the laser hair removal treatment, a handheld laser device is used to deliver a concentrated beam of light to the targeted area of the skin. The energy from the laser is absorbed by the pigment in the hair follicle, which damages the follicle and inhibits its ability to grow new hair.`,
  },
  {
    id: '01',
    title: 'Hair Growth',
    description:
      'If you are experiencing hair loss, thinning hair, or baldness, there are various hair growth treatments available at our clinic that...',
    image: 'https://cdn-icons-png.flaticon.com/512/4303/4303217.png',
    detailDesc: `If you are experiencing hair loss, thinning hair, or baldness, there are various hair growth treatments available at our clinic that can help you restore your hair and confidence. As a dermatologist, I specialize in hair care and offer personalized treatment plans tailored to your unique needs.`,
  },
  {
    id: '08',
    title: 'Other',
    description:
      'At our clinic, we offer a variety of other treatments to help you achieve healthy, radiant skin. These treatments include...',
    image: 'https://i.ibb.co/YbDv4Qn/healthcare.png',
    detailDesc: `Botox and Dermal Fillers: Botox and dermal fillers are injectable treatments that can help to reduce the appearance of fine lines and wrinkles, restore volume to the face, and enhance facial contours. Our dermatologist is trained in the latest injection techniques to achieve natural-looking results.

      IPL (Intense Pulsed Light) Therapy: IPL therapy uses broad-spectrum light to treat a range of skin concerns, including sun damage, age spots, and broken blood vessels. This treatment can help to improve skin texture and tone, giving you a more youthful, radiant appearance.
      
      Skin Tightening: Skin tightening treatments use various technologies, including radiofrequency and ultrasound, to stimulate collagen production and tighten loose or sagging skin. This treatment can be effective for improving the appearance of jowls, neck lines, and other areas of the face and body.
      
      Hair Removal: We offer laser hair removal treatments to help you achieve smooth, hair-free skin. This treatment can be used on a variety of areas, including the face, legs, underarms, and bikini area.`,
  },
  //   {
  //     id: '09',
  //     title: 'Tooth Extractions',
  //     description:
  //       "A tooth extraction, or dental extraction, tooth from its socket in the bone. That's why tooth removal may be necessary.",
  //     image: 'https://i.ibb.co/7rPz3KL/medical-prescription.png',
  //     detailDesc:
  //       'A tooth extraction, or dental extraction, is the removal of a tooth from its socket in the bone. There are a number of reasons why tooth removal may be necessary. Blood bank: : A place where blood is collected from donors, typed, separated into components, stored, and prepared for transfusion to recipients. A tooth extraction, or dental extraction, is the removal of a tooth from its socket in the bone. There are a number of reasons why tooth removal may be necessary.',
  //   },
  //   {
  //     id: '10',
  //     title: 'Teeth Cleanings',
  //     description:
  //       'You should visit the dentist every six months for teeth cleanings. Tartar is a hard buildup of plaque that forms on the teeth.',
  //     image: 'https://i.ibb.co/7rPz3KL/medical-prescription.png',
  //     detailDesc:
  //       'You should visit the dentist every six months for teeth cleanings. Tartar is a hard buildup of plaque that forms on the teeth. Tartar forms below and above the gum line. A tooth extraction, or dental extraction, is the removal of a tooth from its socket in the bone. There are a number of reasons why tooth removal may be necessary. You should visit the dentist every six months for teeth cleanings. Tartar is a hard buildup of plaque that forms on the teeth. Tartar forms below and above the gum line.',
  //   },
  //   {
  //     id: '11',
  //     title: 'Dental Veneers',
  //     description:
  //       'Many people are discovering the benefits of veneers. Veneers are thin coverings that are placed over the front part of the teeth.',
  //     image: 'https://i.ibb.co/9qhyzC1/heart.png',
  //     detailDesc:
  //       'Many people are discovering the benefits of veneers. Veneers are thin coverings that are placed over the front part of the teeth. You should visit the dentist every six months for teeth cleanings. Tartar is a hard buildup of plaque that forms on the teeth. Tartar forms below and above the gum line. Many people are discovering the benefits of veneers. Veneers are thin coverings that are placed over the front part of the teeth.',
  //   },
  //   {
  //     id: '12',
  //     title: 'Medicine Research',
  //     description:
  //       'Medical scientists typically need a Ph. D. or medical degree. Applicants to either of these programs typically need a degree.',
  //     image: 'https://i.ibb.co/rG3MZJp/syringe.png',
  //     detailDesc:
  //       "Medical scientists typically need a Ph. D. or medical degree. Applicants to either of these programs typically need a bachelor's degree in biology. Many people are discovering the benefits of veneers. Veneers are thin coverings that are placed over the front part of the teeth. Medical scientists typically need a Ph. D. or medical degree. Applicants to either of these programs typically need a bachelor's degree in biology.",
  //   },
];
